export const GET_STUDENT_ACCOMMODATIONS = "GET_STUDENT_ACCOMMODATIONS";
export const GET_EXTENDED_COURSES = "GET_EXTENDED_COURSES";
